import React from "react"
import ReactDOM from "react-dom"
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap"
import { HashRouter, Routes, Route } from "react-router-dom";
import "./scss/main.scss"

import App from "./App"

ReactDOM.render(
    <React.StrictMode>
        <HashRouter>
            <App /> 
        </HashRouter>
    </React.StrictMode>,
    document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
